import Vue from 'vue'
import Vuex from 'vuex'
import { i18n } from '@/localization'
import { upload } from '@/services/image/awsUpload'

import axios from '@/services/axios'

Vue.use(Vuex)

export default {
  LOGIN ({ commit, rootState }, { email, password }) {
    const { app } = rootState
    commit('SET_STATE', {
      loading: true,
    })

    return axios.post('/users/login', {
      user_email: email,
      user_password: password,
      user_role: app.type,
      vendor_name: app.name,
    })
      .then(({ data }) => {
        commit('LOGIN', {
          token: data.token,
          store_url: data.user.store_url,
          name: data.user.name,
          email,
          channel_id: data.user.channel_id,
          seller_type: data.user.reseller_type,
          ...data.user,
        })
        commit('SET_STATE', {
          role: data.user.role,
          id: data.user.id,
          email,
          name: data.user.name,
          wallet: data.user.wallet,
          currency: data.user.currency,
          store_url: data.user.store_url,
          is_storeactive: !!data.user.is_storeactive,
        })
        return {
          success: true,
          response: data,
        }
      })
      .catch(err => {
        const { response } = err
        let message = null

        if (response) {
          switch (response.status) {
            case 401:
              message = i18n.t('authForm.invalidPasswordOrUsername')
              break

            case 404:
              message = i18n.t('authForm.invalidPasswordOrUsername')
              break

            default:
              message = i18n.t('authForm.systemBusy')
              break
          }
        }

        if (response.data.message === "Cannot read property 'hash_id' of undefined") {
          message = 'Please check your email, to complete registration'
        }

        message = response?.data?.message ?? 'Internal Server Error'

        if (['true', true].includes(response?.data?.data?.is_block_login)) {
          message = 'Kami membatasi aktifias login pada account anda'
        }

        return {
          success: false,
          code: response?.status,
          message,
        }
      })
      .finally(() => {
        commit('SET_STATE', {
          loading: false,
        })
      })
  },

  FORGOTPASS ({ commit, rootState }, { email }) {
    const { app } = rootState
    commit('SET_STATE', {
      loading: true,
    })
    return axios.put('/users/passwd', {
      user_email: email,
      user_role: app.type,
      vendor_name: app.name,
    },
    {
      headers: {
        storeId: app.vendor_hashid,
      },
    })
      .then(({ data }) => {
        commit('SET_STATE', {
          email: data.user_email,
          confirmpass: {
            link: data.link,
          },
        })
        return {
          success: true,
          response: data,
        }
      })
      .catch(err => {
        const { response } = err
        let message = null

        if (response) {
          switch (response.status) {
            case 404:
              message = i18n.t('authForm.emailNotFound')
              break

            default:
              message = i18n.t('authForm.systemBusy')
              break
          }
        }
        return {
          success: false,
          code: response?.status,
          message,
        }
      })
      .finally(() => {
        commit('SET_STATE', {
          loading: false,
        })
      })
  },

  CONFIRMLINKFORGETPASSWD ({ commit, rootState }, payload) {
    try {
      const { hashId, resetLink } = payload
      const response = axios.get('/users/passwd', {
        params: {
          hashId: hashId,
          token: resetLink,
        },
      })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  RESETPASSWRD ({ commit, rootState }, { payload }) {
    const { password, confirmpassword } = payload
    const { user } = rootState
    const { link, token } = user.confirmpass
    const tokenbar = `Bearer ${token}`
    commit('SET_STATE', {
      loading: true,
    })
    return axios.put('/users/private/resetpasswd', {
      register_link: link,
      new_password: password,
      confirm_password: confirmpassword,
    },
    {
      headers: {
        Authorization: tokenbar,
      },
    })
      .then(({ data }) => {
        return {
          success: true,
          response: data,
        }
      })
      .catch(err => {
        const { response } = err
        let message = null
        if (response) {
          switch (response.status) {
            case 422:
              message = i18n.t('authForm.passwrdNotmatch')
              break

            case 404:
              message = 'storeId unknown!'
              break

            default:
              message = i18n.t('authForm.systemBusy')
              break
          }
        }
        return {
          success: false,
          code: response?.status,
          message,
        }
      })
      .finally(() => {
        commit('SET_STATE', {
          loading: false,
        })
      })
  },

  REGISTER ({ commit, rootState }, { payload }) {
    commit('SET_STATE', {
      loading: true,
    })
    try {
      const {
        name: vendor_name,
        type: user_role,
      } = rootState.app
      const {
        firstname: user_firstname,
        lastname: user_name,
        email: user_email,
        password: user_password,
        phone: user_phone,
      } = payload
      const response = axios.post('/users', {
        vendor_name,
        user_role,
        user_firstname,
        user_name,
        user_email,
        user_password,
        user_phone,
      })
      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    } finally {
      commit('SET_STATE', {
        loading: false,
      })
    }
  },

  async LINKCONFIRMATIONDATAREQ({ commit, rootState, dispatch }, payload) {
    try {
      const { linkId } = payload
      const { data: response } = await axios.get(`/users/getConfirmationData?link=${linkId}`)
      const { token, user } = response
      const { email, id, name, role, vendor, register_id, base_url } = user
      commit('LOGIN', {
        token,
      })
      commit('SET_STATE', {
        role,
        id,
        email,
        name,
        register_id,
        base_url,
      })
      // Get Bank List and Get Region Country based on vendor.id
      const country = await dispatch('data/GETREGIONCOUNTRY', vendor.id, { root: true })
      dispatch('data/GETBANKLIST', null, { root: true })
      dispatch('data/GETCITYLIST', { value: country.value, type: 'city' }, { root: true })
      return Promise.resolve()
    } catch (err) {
      const { response: errResponse } = err
      return Promise.reject(errResponse)
    }
  },

  async REGISTERCONFIRMATION ({ commit, rootState, dispatch }, payload) {
    try {
      commit('SET_STATE', {
        loading: true,
      })
      const { register_id, name, role, email, id } = rootState.user
      const { name: vendor_name } = rootState.app
      const { regionCountry, cityList, areaList } = rootState.data
      const {
        phone,
        address,
        address2,
        zip,
        link,
        // bank,
        // bank_holder_name,
        // account_number,
        storename,
        storeurl,
        image,
        imageNpwp,
        city,
        area,
      } = payload

      const image_data = []

      if (image) {
        const uploadImage = await upload({
          file: image[0].file,
        })
        const image_id = {
          path: '',
          name: uploadImage.filename,
          size: 0,
          type: '',
          ref_id: uploadImage.key,
          content_id: 10,
        }
        image_data.push(image_id)
      }

      if (imageNpwp.length) {
        const uploadImage = await upload({
          file: imageNpwp[0].file,
        })
        const image_npwp = {
          path: '',
          name: uploadImage.filename,
          size: 0,
          type: '',
          ref_id: uploadImage.key,
          content_id: 17,
        }
        image_data.push(image_npwp)
      }

      /**
       * Pada metode a-select option bank list. terdapat nama bank yang sama, Bank Jasa Jakarta
       * Hal ini mengakibatkan penambahan uniqe value untuk menghindari error
       * uniqe value dihilangkan kembali di function ini untuk dikirim ke backend
       */
      // const sliceBank = (bank) => {
      //   const index = bank.indexOf('_')
      //   return bank.slice(0, index)
      // }

      const valueCity = () => {
        const findValue = cityList.find(item => item.label === city)
        return findValue.value
      }

      const valueArea = () => {
        const findValue = areaList.find(item => item.label === area)
        return findValue.value
      }

      const response = await axios({
        method: 'post',
        url: '/users/confirm/seller',
        data: {
          user: {
            register_id,
            name,
            role,
            email,
            phone,
            id,
          },
          address: {
            line1: address,
            line2: !address2 ? '' : address2,
            country_id: Number(regionCountry.value),
            area_id: Number(valueArea()),
            city_id: Number(valueCity()),
            postcode: zip,
          },
          password: '',
          link: link.linkId,
          vendor: {
            name: vendor_name,
          },
          // bank_data: {
          //   name: sliceBank(bank),
          //   account_no: account_number,
          //   account_name: bank_holder_name,
          // },
          seller: {
            name: storename,
            store_name: storeurl,
            seller_type: 'dropship',
          },
          image_data: image || imageNpwp ? image_data : [],
        },
      })
      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    } finally {
      commit('SET_STATE', {
        loading: false,
      })
    }
  },

  async changePassword(_, { password, new_password, confirm_password }) {
    try {
      const { data: response } = await axios.put('/users/private/passwd', {
        password,
        new_password,
        confirm_password,
      })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  },

  LOGOUT({ commit, rootState }) {
    commit('SET_STATE')
    commit('dashboard/SET_STATE', null, { root: true })
    commit('LOGOUT')
  },
}
